import { createLabeledMessages } from '@gef-ui/localization/messageUtils';

const address = {
	addNew: 'přidat',
	addresType: 'typ adresy',
	address: 'adresa',
	addressCheckResult: 'výsledek ověření adresy',
	addressDetail: 'Detail adresy klienta',
	addresses: 'adresy',
	buttonUseManuallyEntered: 'Použít zadanou adresu',
	buttonUseSelected: 'Použít vybranou adresu',
	cityDistrict: 'část obce',
	confirm: 'potvrdit',
	country: 'stát',
	differentTempAddress: 'odlišná korespondenční adresa',
	district: 'okres',
	house: 'sídlo',
	modifiedDate: 'datum modif.',
	modifiedSystemName: 'modif. systém',
	municipality: 'obec',
	permanent: 'trvalá',
	pspu: 'adresa na PS/PU',
	quality: 'kvalita',
	region: 'kraj',
	delete: 'smazat',
	score: 'skóre',
	sourceSystemName: 'zdroj',
	temporary: 'korespondenční',
	type: 'typ adresy',
	useEnteredAddress: 'použít zadanou adresu',
	useSelectedAddress: 'použít vybranou adresu',
	user: 'uživatel',
	fillAddresses: 'Vyplnit adresy',
	postalCode: 'PSČ',
	street: 'ulice',
};

export default Object.assign({}, address, createLabeledMessages(address));
